import React, { useContext, useState } from 'react';
import { SystemContext } from '../SystemBuilder';
import PlusIcon from '@heroicons/react/24/outline/PlusIcon';
import PencilIcon from '@heroicons/react/24/outline/PencilIcon';
import XMarkIcon from '@heroicons/react/24/outline/XMarkIcon';

const SystemCriteria = (props) => {
    const systemContext = useContext(SystemContext);
    const [err, setErr] = useState(false);

    const editCrit = (crit, i) => {
        systemContext.displayCrit(crit.type, crit, i);
    };

    const validateCrit = (e) => {
        e.preventDefault();
        if(systemContext.criteria.length > 0){
            systemContext.setStep(5)
        }else{
            setErr(true);
        };
    };

    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-5 flex justify-between items-center">
                <h2 className="text-xl font-semibold leading-6 text-gray-900 dark:text-white">System Criteria</h2>
                <button
                    type="button"
                    onClick={() => systemContext.setStep(3)}
                    className="rounded-full p-2 text-gray-500 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
                >
                    <PlusIcon className="h-5 w-5" />
                </button>
            </div>

            <div className="rounded-lg border border-gray-200 dark:border-gray-700 divide-y divide-gray-200 dark:divide-gray-700">
                {systemContext.criteria.length > 0 ? (
                    <div className="divide-y divide-gray-200 dark:divide-gray-700">
                        {systemContext.criteria.map((crit, i) => (
                            <div key={i} className="flex items-center justify-between p-4">
                                <span className="text-sm text-gray-900 dark:text-white">{crit.label}</span>
                                <div className="flex items-center space-x-2">
                                    <button
                                        type="button"
                                        onClick={() => editCrit(crit, i)}
                                        className="p-1 text-gray-500 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded"
                                    >
                                        <PencilIcon className="h-4 w-4" />
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => systemContext.removeCrit(i)}
                                        className="p-1 text-gray-500 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded"
                                    >
                                        <XMarkIcon className="h-4 w-4" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="p-4 text-center">
                        <p className="text-sm text-gray-500 dark:text-gray-400">No Criteria</p>
                    </div>
                )}
            </div>

            {err && (
                <p className="text-sm text-brand-red-500 dark:text-brand-red-400">
                    Please add at least one criteria
                </p>
            )}

            <div className="flex items-center justify-end gap-3">
                <button
                    type="button"
                    onClick={() => systemContext.setStep(1)}
                    className="rounded-md bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                    Back
                </button>
                <button
                    type="button"
                    onClick={(e) => validateCrit(e)}
                    className="rounded-md bg-brand-red-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red-500"
                >
                    Backtest
                </button>
            </div>
        </div>
    );
};

export default SystemCriteria;